import { useState, useEffect, useCallback } from 'react';
import { safeGetItem, safeSetItem } from '@/lib/safeStorage';

const STORAGE_KEY = 'human-rooms-last-seen-version';
 const CURRENT_VERSION = '4.3.0';

export const useWhatsNew = () => {
  const [hasNewUpdates, setHasNewUpdates] = useState(false);
  const [lastSeenVersion, setLastSeenVersion] = useState<string | null>(null);

  useEffect(() => {
    const stored = safeGetItem(STORAGE_KEY);
    setLastSeenVersion(stored);
    
    // Show badge if no version stored or version is different
    if (!stored || stored !== CURRENT_VERSION) {
      setHasNewUpdates(true);
    }
  }, []);

  const markAsSeen = useCallback(() => {
    safeSetItem(STORAGE_KEY, CURRENT_VERSION);
    setLastSeenVersion(CURRENT_VERSION);
    setHasNewUpdates(false);
  }, []);

  const getCurrentVersion = useCallback(() => CURRENT_VERSION, []);

  return {
    hasNewUpdates,
    lastSeenVersion,
    currentVersion: CURRENT_VERSION,
    markAsSeen,
    getCurrentVersion,
  };
};
